<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Dealing with Peer Pressure and Social Anxiety in School." subtitle="Dealing with Peer Pressure and Social Anxiety in School."></app-page-banner>
        <!-- INNER PAGE BANNER END -->

        <!-- OUR BLOG START -->
        <div class="section-full  p-t120 p-b90 bg-white">
            <div class="container">

                <!-- BLOG SECTION START -->
                <div >
                    <div class="row d-flex justify-content-center mobilerow">

                        <div class="blog-post blog-post-4-outer m-b30" >
                            <!-- <div class="wt-post-title ">
                                <h4 class="post-title"><a routerLink="javascript:void(0)">Why Mental Health Should Be a Priority in Schools</a></h4>
                            </div> -->
                            <div>
                               <p style="font-style: italic;">It’s hard to stand out when you’re afraid of not fitting in.</p>

                                     
                                        <p>
                                            Peer pressure and social anxiety are two of the biggest challenges students face.
                                            While friendships and social interactions are essential for growth, the pressure to
                                            conform or the fear of judgment can harm a student’s mental health.
                                        </p>
                                       
                            </div>
                           

                            <div class="wt-post-media wt-img-effect zoom-slow" style="margin-top: 15px;">
                                <a routerLink="javascript:void(0)"><img src="assets/images/shes-victim-of-bullying-2023-11-27-05-31-36-utc.jpg" alt=""></a>
                            </div>
                            <div class="wt-post-info mobcon">
                                <!-- <div class="wt-post-meta ">
                                    <ul>
                                        <li class="post-date"><span>{{blog.day}}</span>{{blog.month}}</li>
                                        <li class="post-category">{{blog.field}}</li>
                                    </ul>
                                </div> -->
                                
                                <div class="wt-post-text ">
                          
                                    <h6 class="post-title"> <a routerLink="javascript:void(0)">Understanding the Challenges:</a></h6>
                                    <h6 class="post-title" style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">1. Peer Pressure</a></h6>
                                    <ul style="margin-left: 56px; ">    
                                        <li style="margin-left: 56px; ">Feeling pressured to act in ways that go against one’s values
                                            to fit in.</li>
                                        <li style="margin-left: 56px; ">Experiencing fear of exclusion or ridicule for not
                                            conforming.</li>
                                    </ul>
                        
                                        <h6 class="post-title" style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)"> 2. Social Anxiety</a></h6>
                                        <ul style="margin-left: 56px; ">    
                                            <li style="margin-left: 56px; ">Intense fear of being judged, leading to avoidance of social
                                                situations.</li>
                                            <li style="margin-left: 56px; ">Difficulty speaking up in class or participating in group
                                                activities.</li>
                                        </ul>

                        
                                        <h6 class="post-title"> <a routerLink="javascript:void(0)">Strategies for Students:</a></h6>
                                            <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">1. Practice Self-Awareness</a></h6>
                                            <p style="margin-left: 56px; ">Help students understand their values and build confidence in saying no to
                                                negative influences.</p>
                                        <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">2. Develop Social Skills</a></h6>
                                        <p style="margin-left: 56px; ">Role-playing and communication exercises can help students handle
                                            social situations with ease.</p>
                                        <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">3. Build a Support System</a></h6>
                                        <p style="margin-left: 56px; ">Encourage friendships with peers who uplift and encourage individuality.</p>
                                       
                                        <h6 class="post-title"> <a routerLink="javascript:void(0)">How Soul Space Can Help?</a></h6>
                                        <p>We offer workshops that teach students how to navigate peer pressure and manage
                                            social anxiety effectively. <a href="javascript:void(0);" routerLink="/contact" style="color: #007bff !important;">Sign Up for a Workshop</a> to help your students thrive.</p>
                                       
                                </div>
                                <!-- <div class="wt-post-readmore ">
                                    <a routerLink="javascript:void(0)" class="site-button-link black">Read More</a>
                                </div> -->
                            </div>
                        
                            
                        </div>

                        <!-- SIDE BAR START -->
           
                        <!-- SIDE BAR END -->


                    </div>

                </div>

            </div>

        </div>
        <!-- OUR BLOG END -->


    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>